import Engine from "client/classes/Engine";
import { removeURLParam } from "client/classes/utilities/Misc";
import Button from "client/components/layout/Button";

import { StoreActions } from "src/state/store";
import { useTypedDispatch } from "src/state/hooks";

interface IExitScenarioDialogProps
{
	onShutdown?: () => void,
}

const ExitScenarioDialog = (props: IExitScenarioDialogProps) =>
{
	const dispatch = useTypedDispatch();

	return (
		<div className={"exitScenarioDialogRoot"}
			data-name={"exit-scenario-dialog-root"}
		>
			<div className={"exitScenarioDialogTitle"}>
				Exit Scenario
			</div>
			<div className={"exitScenarioDialogContent"}>
				Exit Scenario?
			</div>
			<div className={"dialogActionsBar"}>
				<Button label={"Exit"} 
					onClick={() => 
					{
						removeURLParam('projectid');
						dispatch(StoreActions.scenario.clearScenario());
						dispatch(StoreActions.visage.clearUIData());
						Engine.getInstance().clearProjectData();
						props.onShutdown?.();
					}}
				/>
				<Button label={"Cancel"} 
					onClick={props.onShutdown}
				/>
			</div>
		</div>
	);
};

export default ExitScenarioDialog;